import { businessType as businessTypes } from '@routable/companies-management';
export const canBusinessUseTinTypeSSN = (businessType) => businessType === businessTypes.Enum.llc_single_member ||
    businessType === businessTypes.Enum.sole_proprietorship ||
    businessType === businessTypes.Enum.trust_estate;
